import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { ListingStatusComponent } from '@/Components/Listings/Status';

export const FeaturedStatusFragment = () => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

    return (
        <Elements stripe={stripePromise}>
            <ListingStatusComponent />
        </Elements>
    )
}
